import { createComponentById } from '@vfde-brix/ws10/core';
import { Gigakombi, HtmlId } from '../enum';
import { OptionPicker, createOptionPicker } from '@vfde-brix/ws10/option-picker';
import { Customer } from '@vfde-sails/login';
import optionPickerUtils from '../util/component/optionPicker.utils';
import { ProductContainerProps } from '../container/Product';

export const mountOptionPicker = (id: HtmlId, action?: (value: string) => void) =>
    createComponentById(createOptionPicker, id, {
        onChange: ({ target }) => {
            if (target instanceof HTMLInputElement) {
                action?.(target.value);
            }
        },
    });

/**
 * Update OptionPicker component used for selecting type, option, or device
 * @param {OptionPicker | null} comp - component to update
 */
export const updateOptionPickerSelection = (comp: OptionPicker | null, selected: string) => {
    if (!comp) {
        return;
    }

    const props = comp.getProperties();

    props.items.forEach(item => {
        item.optChecked = item.stdValue === selected;
    });

    comp.update(props);
};

export const updateProductPicker = (comp: OptionPicker | null, stateProps: ProductContainerProps) => {
    if (!comp) {
        return;
    }

    const props = comp.getProperties();

    props.items = props.items.map((item) => optionPickerUtils.getProductPickerItem(item, stateProps));

    comp.update(props);
};

export const updateGigakombiPicker = (comp: OptionPicker | null, selected: Gigakombi, customer?: Customer) => {
    if (!comp) {
        return;
    }

    const props = comp.getProperties();

    props.items = props.items.map((item) => optionPickerUtils.getGigakombiPickerItem(item, selected, customer));

    comp.update(props);
};
